import { createContext, useContext } from 'react';
import { rowEntries, type AnswerOrigins, type ReactionStates } from '@ayumia/component-runtime';
import type { Entry } from './form-targets';

/**
 * Réactions vues par les champs d'une fiche (ADR-146 addenda (17) et (21)) : les origines des réponses
 * (marque « proposée ») et les états dérivés par ligne (choix rechargés et filtre du sélecteur d'une ligne
 * par sa propre ligne). Fournies par `TemplateForm` ; absentes (aperçu d'un composant seul), rien ne change.
 * Présentation seulement : le serveur rejoue tout à la complétion.
 */
export interface FormReactionsView {
  origins: AnswerOrigins;
  states: ReactionStates | null;
}

export const FormReactionsContext = createContext<FormReactionsView>({ origins: {}, states: null });

/** Vrai si la réponse de ce chemin est une suggestion d'une réaction, non modifiée par l'opérateur. */
export function useSuggested(path: string | undefined): boolean {
  const { origins } = useContext(FormReactionsContext);
  return path !== undefined && origins[path] !== undefined;
}

/** Champs d'une ligne tels que l'écran les rend : choix et filtre rechargés par sa propre ligne. */
export function useRowEntries(): (entries: readonly Entry[], sectionId: string, index: number) => Entry[] {
  const { states } = useContext(FormReactionsContext);
  return (entries, sectionId, index) => (states === null ? [...entries] : (rowEntries(entries as never, states, sectionId, index) as unknown as Entry[]));
}
